var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 27,
  height: 27,
  viewBox: "0 0 27 27"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "Rectangle_297",
  x: 0,
  y: 0,
  width: 27,
  height: 27,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 1,
  input: "SourceAlpha"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5,
  result: "blur"
}), /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0.329
}), /*#__PURE__*/React.createElement("feComposite", {
  operator: "in",
  in2: "blur"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "SourceGraphic"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group_2199",
  "data-name": "Group 2199",
  transform: "translate(-769.5 415.5)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1, 0, 0, 1, 769.5, -415.5)",
  filter: "url(#Rectangle_297)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_297-2",
  "data-name": "Rectangle 297",
  width: 24,
  height: 24,
  rx: 12,
  transform: "translate(1.5 0.5)",
  fill: "#78e2cb"
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_29",
  "data-name": "Path 29",
  d: "M11.423,12.313l-.328-.542C8.6,7.643,6.352,7.4,5.508,7.525V10.8L0,5.377,5.508,0V3.231a6.917,6.917,0,0,1,4.618,1.322c3.37,2.758,1.426,7.1,1.419,7.142ZM6.271,6.99c1.409,0,2.772.941,4.853,3.933.031-1.172,1.005-4.105-1.321-6.01a6.693,6.693,0,0,0-4.532-1.2l-.252.007V1.155L.693,5.378,5.019,9.642V7.137L5.2,7.092A4.893,4.893,0,0,1,6.271,6.99Z",
  transform: "translate(776.984 -409.413) rotate(3)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_28",
  "data-name": "Path 28",
  d: "M5.986,6.784V4.046L1.475,8.24l4.418,4.484.09-2.586s3.147-.865,5.9,3.761a5.308,5.308,0,0,0-1.467-6.126A7.336,7.336,0,0,0,5.986,6.784Z",
  transform: "translate(776.28 -412.445) rotate(3)",
  fill: "#26b99a"
}))));
export default __webpack_public_path__ + "static/media/buyback-active.e86604ca.svg";
export { SvgComponent as ReactComponent };